//    ╔═╗┌─┐┌┐┌┌─┐┬ ┬┌┬┐┌─┐  ┌┬┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐  ┬ ┬┌─┐┌┐
//    ║  │ ││││└─┐│ │││││ │   ││├┤   └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐  │││├┤ ├┴┐
//    ╚═╝└─┘┘└┘└─┘└─┘┴ ┴└─┘  ─┴┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘  └┴┘└─┘└─┘

import {Injectable} from '@angular/core';
import {Usuario} from '../modelo/usuario';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {UtilConfig} from "../../../../../../autenticacion/servicios/UtilConfig";

declare var $: any;

@Injectable()
export class UsuariosService {
    URL_LIST_USUARIO = "/seguridad/usuario/buscar";
    URL_GET_USUARIO = "/seguridad/usuario/consultar";
    URL_GET_COMBOS = "/seguridad/usuario/obtenerCombos";
    URL_ACTUALIZAR_COMBOS = "/seguridad/usuario/actualizar";
    URL_FOTO_TEMPORAL = "/seguridad/usuario/fotoTemporal";
    URL_ELIMINAR_USUARIO = "/seguridad/usuario/inactivar";
    URL_ACTIVAR_USUARIO = "/seguridad/usuario/activar";

    constructor(private jwtUtil: UtilConfig, private http: Http) {
    }

    search(term: string, estado: string): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_LIST_USUARIO;
        let filtro = {
            criterio: term ? term : "",
            estado: (estado == 'TODOS') ? null : estado
        };
        let body = JSON.stringify(filtro);
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        return this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }

    getUsuario(idParam: number): Observable<Usuario> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_GET_USUARIO;
        let usuarioVar = {id: idParam};
        let body = JSON.stringify({usuario: usuarioVar});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());

        return this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                let item = res.json().usuario;
                if (item) {
                    return new Usuario(item.id,
                        item.cedula,
                        item.nombres,
                        item.apellidos,
                        item.customer,
                        item.username,
                        item.foto,
                        item.direccion,
                        item.telefonoPrincipal,
                        item.telefonoSecundario,
                        item.fechaUltimoIngreso,
                        item.fechaCaducidadClave,
                        item.rol,
                        item.logEstatusRegistro,
                        item.logUsernameRegistro,
                        item.logFechaRegistro,
                        item.logUsernameModificacion,
                        item.logFechaModificacion,
                        item.origen,
                        item.lstFuncionalidades);
                }

            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    getCombos(): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_GET_COMBOS;
        let body = JSON.stringify({});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        return this.http.post(url, body, {headers: headers})
            .map(res => {
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
    }


    actualizarUsuario(usuario: any): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_ACTUALIZAR_COMBOS;
        let fotoTemporal = usuario.foto;

        if (usuario.telefonoSecundario == "")
            usuario.telefonoSecundario = null;
        let body = JSON.stringify({usuario: usuario});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        let respuesta: any;
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        respuesta = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        usuario.foto = fotoTemporal;
        return respuesta;
    }


    getFotoPerfilTemporal(name: string): Observable<string> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_FOTO_TEMPORAL;
        let body = JSON.stringify({nombreFoto: name});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        let respuesta: any;
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        respuesta = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json().fotoTemporal;
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return respuesta;
    }


    eliminar(item: Usuario): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_ELIMINAR_USUARIO;
        let body = JSON.stringify({usuario: item});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        let respuesta: any;
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        respuesta = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return respuesta;
    }

    activar(item: Usuario): Observable<any> {
        let url = this.jwtUtil.URL_WS_BACKEND + this.URL_ACTIVAR_USUARIO;
        let body = JSON.stringify({usuario: item});
        let headers = new Headers({'Content-Type': 'application/json; charset=UTF-8'});
        let respuesta: any;
        headers.append('authorization', this.jwtUtil.createAuthorizationTokenHeader());
        respuesta = this.http.post(url, body, {headers: headers})
            .map(res => {
                this.jwtUtil.setJwtToken(res.json().token);
                return res.json();
            })
            .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
        return respuesta;
    }


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/usuario/recursos/servicios/usuarios.service.ts